export default "__VITE_ASSET__DiCvaKdU__"